import type { I18nTranslations } from "./types"

export const ptTranslations: I18nTranslations = {
  dashboard: {
    title: "Painel",
    welcome: "Bem-vindo(a) de volta",
    editMode: "Editar Widgets",
  },
}
